import { Logo } from '@/view/components/ui/logo'

export default function InstallmentsSkeleton() {
  return (
    <div className="flex min-h-screen w-full flex-col items-center justify-center">
      <div className="flex w-full max-w-xl items-center justify-center bg-white02 px-8 py-10">
        <div className="w-full">
          <div className="mb-6 rounded-lg border border-gray02 bg-white02 py-3 text-center">
            <div className="mx-auto h-6 w-48 animate-pulse rounded bg-gray-200"></div>
          </div>

          <div className="mb-8 flex flex-col items-center">
            <div className="mb-8 h-20">
              <Logo className="h-full object-contain" />
            </div>
            <div className="mb-2 h-5 w-32 animate-pulse rounded bg-gray-200"></div>
            <div className="mt-2 flex items-center gap-2">
              <div className="h-10 w-32 animate-pulse rounded bg-gray-200"></div>
              <div className="ml-2 h-8 w-16 animate-pulse rounded-full bg-gray-200"></div>
            </div>
            <div className="mt-2 h-4 w-48 animate-pulse rounded bg-gray-200"></div>
          </div>

          <div className="mb-6">
            <div className="h-14 w-full animate-pulse rounded-xl bg-black02"></div>
          </div>

          <div className="mb-8 mt-2 rounded-xl bg-white02 px-5 py-4">
            {Array.from({ length: 5 }).map((_, index) => (
              <div key={index} className="flex justify-between py-1">
                <div className="h-4 w-24 animate-pulse rounded bg-white02"></div>
                <div className="h-4 w-20 animate-pulse rounded bg-white02"></div>
              </div>
            ))}
          </div>

          <div className="mb-6">
            <div className="flex w-full items-center gap-3 rounded-xl border border-primary bg-gray01 px-6 py-5">
              <div className="h-6 w-6 animate-pulse rounded bg-white02"></div>
              <div className="flex flex-1 flex-col items-start space-y-2">
                <div className="h-6 w-32 animate-pulse rounded bg-white02"></div>
                <div className="h-4 w-40 animate-pulse rounded bg-white02"></div>
              </div>
              <div className="ml-auto h-5 w-5 animate-pulse rounded bg-white02"></div>
            </div>
          </div>

          <div className="h-14 w-full animate-pulse rounded-xl bg-white"></div>
        </div>
      </div>
    </div>
  )
}
